import { Button } from '@shared/components/button';
import { CircularProgress } from '@shared/components/circular-progress';
import { Text } from '@shared/components/text';
import { useComputeRates } from '../hooks/useComputeRates';

type CollectRatesButtonProps = {
  quoteId: string;
  variant?: 'primary' | 'secondary';
};

export function CollectRatesButton(p: CollectRatesButtonProps) {
  const { compute, loading } = useComputeRates();

  if (loading) {
    return (
      <div className="flex cursor-progress items-center justify-center gap-1 rounded-md border border-gray-200 p-1 px-2 shadow-sm">
        <Text type="body-xs">Fetching...</Text>
        <CircularProgress size="xs" className="text-brand-500" />
      </div>
    );
  }

  return (
    <Button
      iconPosition="right"
      size="small"
      variant={p.variant ?? 'secondary'}
      onPress={() => compute(p.quoteId)}
    >
      Get rates
    </Button>
  );
}
